// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__306Oq","title":"Images90_title__zD8il","images":"Images90_images__2dAAC"};